export default __webpack_public_path__ + "static/media/vk.dcea53f8.svg";